import { render, staticRenderFns } from "./WatchComponentsContainer.vue?vue&type=template&id=92c0d1b6&"
import script from "./WatchComponentsContainer.vue?vue&type=script&lang=ts&"
export * from "./WatchComponentsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./WatchComponentsContainer.vue?vue&type=style&index=0&id=92c0d1b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports